import React, { useEffect } from 'react';
import styles from './customer-calendar-card.module.scss';
import { MiniBooking } from 'features/index';
import { businessStore, dayCalendarStore } from 'entities/index';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

export const CustomerCalendarCard = observer(() => {
  const params = useParams();
  const pointId = businessStore.pointId || params.pointId;

  useEffect(() => {
    if (pointId) {
      businessStore.initServicesList(pointId);
      businessStore.initPointHeaderData(pointId);
    }
  }, [pointId]);

  return (
    <div className={styles.customer_calendar_card__container}>
      <div className={styles.container__content}>
        <div className={styles.content__booking}>
          <MiniBooking date={dayCalendarStore.getSelectedDate} />
        </div>
      </div>
    </div>
  );
});
